import React, { useEffect,useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Datatables from "component/booking/Datatables";
import DetailBooking from "component/booking/DetailBooking";

function Pending() {
  const [activeContent, setActiveContent] = useState("booking");
  const [selectedPending, setSelectedPending] = useState(null);
  const [pending, setPending] = useState([]);

  const fetchPending = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/show-booking`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ status: "PENDING" })
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data booking pending");
  
      const data = await response.json();
      setPending(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      console.error("Error fetching pending:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Booking Pending";
      window.scrollTo(0, 0);
      fetchPending();
  }, []);


  const handleDetailBooking = (DetailBooking) => {
    setActiveContent("DetailBooking");
    setSelectedPending(DetailBooking);
  }

    const handleConfirmBooking = async (invoice, action, room_id) => {
      try {
        if (!invoice) {
          alert("Invoice tidak ditemukan");
          return;
        }

        const payload = {
          invoice: invoice,
          status: action === "accept" ? "Accepted" : "Rejected",
          room_id,
        };

        const response = await axios.put(
          `${process.env.REACT_APP_API}/booking-confirm`,
          payload
        );

        if (response.status === 200 || response.status === 201) {
          showSuccess(response.data.message || "Confirm booking berhasil");
          handleBack();
        } else {
          showError(response.data.message || "Gagal Confirm Booking");
        }
      } catch (error) {
        console.error("Error confirm booking:", error);
        showError(error.response?.data?.message || "Terjadi kesalahan saat confirm booking");
      }
    };

    const handleBack = () => {
        fetchPending();
        setActiveContent("booking");
    };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">

                          {activeContent === "booking" && (
                            <div className="row content-item">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-3">Pending Booking</h5>
                              </div>
                              <Datatables
                                data={pending}
                                onDetailBooking={handleDetailBooking}
                                responsive
                                dense
                              />
                            </div>
                          )}

                          {activeContent === "DetailBooking" && (
                            <div className="row content-item">
                              <DetailBooking
                                booking={selectedPending}
                                onBack={handleBack}
                                onStatusBooking={handleConfirmBooking}
                              />
                            </div>
                          )}

                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>
 
    </div>
  );
}

export default Pending;
